export default class AuthInfo {
  employee?: Employee;
  accessToken?: string;
  refreshToken?: string;
  accessTokenExpiresIn?: number;
  refreshTokenExpiresIn?: number;
  accessTokenExpirationDate?: Date;
  refreshTokenExpirationDate?: Date;

  calculateExpirationDate() {
    const now = Date.now();
    const accessTokenMs = this.accessTokenExpiresIn * 1000;
    const refreshTokenMs = this.refreshTokenExpiresIn * 1000;
    this.accessTokenExpirationDate = new Date(now + accessTokenMs);
    this.refreshTokenExpirationDate = new Date(now + refreshTokenMs);
  }
}